import {
  ROUTE_PATH_LIST,
  ROUTE_PATH_LIST_SETTINGS,
} from '../../../constants/route'

export const CALENDAR_VIEW_NO_TASK_TYPES_COUNT = 0

export const CALENDAR_VIEW_SETTINGS_PATH = `/${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.calendar}`

export const QA_NAME_CALENDAR_NO_TASK_TYPES = 'calendarNoTaskTypes'

export const QA_NAME_CALENDAR_TASK_NOTE = 'calendarTaskNote'
